/** @format */

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import api from "../api/api";
import Footer from "../components/Footer";
import Headers from "../components/Headers";
import { useCategories } from "../utils/Categories";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const { categories, loading, clientLocation } = useCategories();

  const { t } = useTranslation();

  const sendOtp = async () => {
    try {
      const res = await api.post(
        `${process.env.REACT_APP_SERVER_URL}/api/customer/send-customer-reset-otp`,
        { email },
      );
      setMessage(res.data.message);
      setStep(2);
    } catch (error) {
      setMessage(error.response?.data?.message || `${t("Error")}`);
    }
  };

  const verifyOtp = async () => {
    try {
      const res = await api.post(
        `${process.env.REACT_APP_SERVER_URL}/api/customer/verify-customer-reset-otp`,
        { email, otp },
      );
      setMessage(res.data.message);
      setStep(3);
    } catch (error) {
      setMessage(error.response?.data?.message || "OTP incorrect");
    }
  };

  const resetPassword = async () => {
    try {
      const res = await api.post(
        `${process.env.REACT_APP_SERVER_URL}/api/customer/reset-customer-password`,
        { email, password, otp },
      );
      setMessage(res.data.message);
      setStep(4); // fin
    } catch (error) {
      setMessage(error.response?.data?.message || `${t("Update error")}`);
    }
  };

  return (
    <div>
      {loading && (
        <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-gray-500/70 z-[99999]'>
          <FadeLoader />
        </div>
      )}
      <Headers categories={categories} clientLocation={clientLocation} />
      <div className='bg-slate-200 mt-4'>
        <div className='w-full justify-center items-center p-10'>
          <div className='max-w-md mx-auto mt-10 p-6 border bg-slate-50 rounded shadow'>
            <h2 className='text-xl font-bold mb-4 text-center'>
              {t("Forgotten password")}
            </h2>

            {step === 1 && (
              <>
                <input
                  type='email'
                  placeholder={t("Your email")}
                  className='w-full p-2 border mb-4'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  onClick={sendOtp}
                  className='w-full bg-blue-600 text-white py-2 rounded'
                >
                  {t("Send OTP")}
                </button>
              </>
            )}

            {step === 2 && (
              <>
                <input
                  type='text'
                  placeholder='Code OTP'
                  className='w-full p-2 border mb-4'
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                <button
                  onClick={verifyOtp}
                  className='w-full bg-green-600 text-white py-2 rounded'
                >
                  {t("Check")}
                </button>
              </>
            )}

            {step === 3 && (
              <>
                <input
                  type='password'
                  placeholder={t("New Password")}
                  className='w-full p-2 border mb-4'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  onClick={resetPassword}
                  className='w-full bg-purple-600 text-white py-2 rounded'
                >
                  {t("Reset")}
                </button>
              </>
            )}

            {step === 4 && (
              <>
                <p className='text-green-600 font-medium text-center'>
                  {t("Password updated successfully!")}
                </p>

                <div className='flex items-center mb-3 gap-3 justify-center text-2xl font-bold'>
                  <p>
                    {" "}
                    <Link to='/login' className='text-blue-500'>
                      {t("Login")}
                    </Link>
                  </p>
                </div>
              </>
            )}
            {message && (
              <p className='mt-4 text-center text-sm text-gray-700'>
                {message}
              </p>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ForgotPassword;
